//default base url

// const API_URL = "https://airflight-api.onrender.com/api/v1/";
// const API_URL = "https://api-sterling-prod.cyclic.app/api/v1/";
const API_URL =
  "https://4ogc7tjf5d.execute-api.us-east-1.amazonaws.com/api/v1/";

export default API_URL;
